import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["tabIndex", "rel", "target", "data-disabled", "data-selected", "href"]
const _hoisted_2 = ["data-disabled", "data-selected"]

import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';

import { createStyle } from '@v1/composables/create-style';
import { StyleExtender } from '@v1/composables/style-extender';
import { useKeyboard } from '@v1/composables/use-keyboard';
import { useTruncateStyle } from '@v1/composables/use-styles';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseLink',
  props: {
  alignCenter: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  selected: {
    type: Boolean,
    required: false,
    default: false,
  },
  disableStopPropagation: {
    type: Boolean,
    required: false,
    default: false,
  },
  disableTruncate: {
    type: Boolean,
    required: false,
    default: false,
  },
  href: {
    type: [Object, String],
    required: false,
    default: null,
  },
  inline: {
    type: Boolean,
    required: false,
    default: false,
  },
  inlineBlock: {
    type: Boolean,
    required: false,
    defualt: false,
  },
  openInCurrentTab: {
    type: Boolean,
    required: false,
    default: false,
  },
  to: {
    type: Object,
    required: false,
    default: null,
  },
  styleExtension: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  asReactive: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const styleExtender = new StyleExtender({
  variablePrefix: '--v1-base-link',
  extraVariablePostfixes: ['selected', 'focusVisible'],
});

const router = useRouter();

const props = __props;

// computed
const rel = computed(() => (props.openInCurrentTab ? null : 'noopener noreferrer'));
const target = computed(() => (props.openInCurrentTab ? '_self' : '_blank'));
const truncate = computed(() => (
  !props.disableTruncate
  && !props.inline
  && !props.inlineBlock));

// data
const truncateStyle = ref({
  ...useTruncateStyle(),
  ...(props.alignCenter ? {
    alignItems: 'center',
    display: 'flex',
  } : {}),
});

const container = ref<HTMLElement | null>(null);

const style = createStyle({
  container: {},
  inner: {},
}, {
  asReactive: props.asReactive,
});

styleExtender.extend({
  target: style.container,
  extension: props.styleExtension.container,
  selector: 'container',
});

styleExtender.extend({
  target: style.inner,
  extension: props.styleExtension.inner,
  selector: 'inner',
});

if (props.inline || props.inlineBlock) {
  style.container.display = props.inline ? 'inline' : 'inline-block';
  style.container.verticalAlign = 'top';

  if (style.inner.display === 'flex') {
    // Do not use inline-block. 'inline-block' disallow wrapping text
    // and it's not expected behavior as inline element.
    style.inner.display = 'inline';
  }
}
// methods
const onClick = (e: MouseEvent) => {
  if (!props.disableStopPropagation) e.stopPropagation();
  if (!props.disabled && props.to) router.push(props.to);
  container.value.blur();
};

const clickByKeydown = (e: KeyboardEvent): void => {
  if (!props.disableStopPropagation) e.stopPropagation();
  if (!props.disabled && props.to) router.push(props.to);
  if (!props.disabled && props.href) container.value.click();
  container.value.blur();
};

const { onKeydown, onKeyup } = useKeyboard({
  keydownCallbacks: {
    ' ': clickByKeydown,
    Enter: clickByKeydown,
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", _mergeProps(_ctx.$attrs, {
    tabIndex: __props.disabled ? null : 0,
    ref_key: "container",
    ref: container,
    rel: rel.value,
    target: target.value,
    "data-disabled": __props.disabled,
    "data-selected": __props.selected,
    href: __props.disabled ? null : __props.href,
    onClick: onClick,
    onKeydown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onKeydown) && _unref(onKeydown)(...args))),
    onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onKeyup) && _unref(onKeyup)(...args))),
    class: _ctx.$style.container,
    style: _unref(style).container
  }), [
    _createElementVNode("div", {
      "data-disabled": __props.disabled,
      "data-selected": __props.selected,
      class: _normalizeClass(_ctx.$style.inner),
      style: _normalizeStyle(_unref(style).inner)
    }, [
      (truncate.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle(truncateStyle.value)
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 4))
        : _renderSlot(_ctx.$slots, "default", { key: 1 })
    ], 14, _hoisted_2)
  ], 16, _hoisted_1))
}
}

})